import { memo } from 'react';
import { FileTextIcon, ImageIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ICON_ROTATION = {
  LEFT: -20,
  RIGHT: 20,
} as const;

const DROP_SHADOW = 'drop-shadow(0 3.214px 18.4px rgba(0, 0, 0, 0.11))';

interface IconContainerProps {
  rotation: number;
  children: React.ReactNode;
  className?: string;
}

const IconContainer = memo(({ rotation, children, className = '' }: IconContainerProps) => (
  <div
    className={`size-12 bg-background grid place-items-center rounded-md ${className}`}
    style={{
      transform: `rotate(${rotation}deg)`,
      filter: DROP_SHADOW,
    }}
  >
    {children}
  </div>
));
IconContainer.displayName = 'IconContainer';

export const InternalChatDropzone = memo(() => {
  const { t } = useTranslation('chats');

  return (
    <div
      className="flex flex-col items-center justify-center gap-y-5.5 top-0 left-0 w-full h-full"
      role="region"
      aria-label={t('chats.internalChatDropzone.fileDropZone')}
      aria-describedby="dropzone-description"
    >
      <div className="flex">
        <IconContainer rotation={ICON_ROTATION.LEFT} className="-mr-3 z-2">
          <FileTextIcon aria-hidden className="size-6 text-foreground" />
        </IconContainer>
        <IconContainer rotation={ICON_ROTATION.RIGHT}>
          <ImageIcon aria-hidden className="size-6 text-foreground" />
        </IconContainer>
      </div>
      {/* Sits on ChatDropzone's fixed dark scrim, so the label needs the light-on-dark token. */}
      <p className="text-4xl font-normal text-primary-foreground">
        {t('chats.internalChatDropzone.dropYourFilesHere')}
      </p>
    </div>
  );
});

InternalChatDropzone.displayName = 'InternalChatDropzone';
